export default function CredentialList({ items }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {items.map((item, i) => (
        <div
          key={item.title}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            gap: 24,
            padding: '18px 0',
            borderBottom: i === items.length - 1 ? 'none' : '1px solid var(--line)',
          }}
        >
          <span
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 400,
              fontSize: 22,
              color: 'var(--ink)',
              letterSpacing: '-0.005em',
            }}
          >
            {item.title}
          </span>
          <span
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 13,
              color: 'var(--ink-3)',
              textAlign: 'right',
              flexShrink: 0,
            }}
          >
            {item.where}
          </span>
        </div>
      ))}
    </div>
  );
}
